// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".family-members__plus-icon span{display:unset}@media only screen and (max-width: 1250px)and (min-width: 768px){.family-members__link-btn span,.family-members__edit-btn span{display:none}.relationship-card-header__add-btn span{display:none}}.family-members .choices__list--dropdown .choices__list{max-height:210px}@media only screen and (max-height: 800px){.family-members .choices__list--dropdown .choices__list{max-height:100px}}", ""]);
// Exports
module.exports = exports;
